import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { deleteUsers, getUsersById, getUsersByQuery, patchUsers } from "components/axios/userAxios";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import CustomFormEnumSelect from "components/select/CustomFormEnumSelect";
import { useEnumApi } from "contexts/EnumApiContext";
import { useTranslation } from "react-i18next";
import { getCheckDupleEmail } from "components/axios/joinAxios";
import { ROLE } from "data/data";
import { writeAuditLog } from "components/axios/auditLogger";

const UserModifySetting = () => {
  const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode } = useEnumApi();
  const { t } = useTranslation();
  const {id} = useParams();
  //let qs = queryString.parse(window.location.search);

  // modal 관련
  const { openModal } = useModals();
  const [saCount, setSaCount] = useState(0);
  
  const handleAlertClick = (alertMessage) => {
    openModal(modals.alertModal, {
      onClose : () => {
       // console.log(1111);
      },
      message: alertMessage,
      });
  };

  const { control, register, handleSubmit, reset, setValue, formState : {isDirty, errors } } = useForm({});
  // const statuss = [{code:'NR', title:'정상'},{code:'WI', title:'대기'},{code:'ST', title:'정지'}];
  // const [statusTypes] = useState([{code:1,title:"정상"},{code:0,title:"정지"}]);
  const [user, setUser] = useState({});
  // const [isCheck, setIsCheck] = useState(false);
  // const [userId, setUserId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailCheck, setIsEmailCheck] = useState(false);
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState();

  //email& 비밀번호 정규식  
  const emailRegEx = /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;
  // const passwordRegEx = /^[A-Za-z0-9]{8,20}$/
  const passwordRegEx = /^\S{8,20}$/; // 설명: 공백문자 없이 8~20자 (공백 포함 불허)
  
  useEffect(()=>{
    getUsersByQuery({role:ROLE.SA.code}).then((data)=>{
      // console.log(data);
      if (data && data.page) {
        setSaCount(data.page.totalElements);
      }
    })
  },[]);

  useEffect(()=>{
    if (!isLoading) {
      getUsersById(id).then((data)=>{
      // console.log(">>> 3", data);
        setUser(data);
        setValue('name', data.name ?? '');
        setValue('contact', data.contact ?? '');
        setValue('email', data.email ?? '');
        setValue('status', data.loginActiveStatus ?? '');
        if (data.company) {
          setCompany(data.company);
        }
        // setUserId(data.loginId);
        setIsLoading(true);
        // setIsCheck(true);
        if (data.email) {
          setEmail(data.email)
          setIsEmailCheck(true);
        }
      });
    }
  },[isLoading, id]);

  useEffect(()=>{
    if (user) {
      setValue("loginId",user.loginId);
      setValue("name",user.name);
      // setValue("telNo",user.telNo);
      setValue("email",user.email);
      // setValue("emailRecvYn",user.emailRecvYn || null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[user]);

  // 수정
  let onSubmit = (data) => {
    console.log(data);

    // const id      = data.id;
    const roleCode      = data.roleCode;
    const name      = data.name;
    const loginId   = data.loginId;
    const password  = data.password;
    const password2 = data.password2;
    const contact   = data.contact;
    const email     = data.email;

    // console.log('modify');
    
    if (!isEmailCheck) {
      handleAlertClick(t('message.common.alert.email.duplication.check'));
      return;
    }

    if (password !== password2) {
      handleAlertClick(t('message.common.alert.password.check.re-enter'));
      return;
    }

    let body = {
      id : id,
      // role : roleCode,
      name,
      loginId,
      password,
      contact,
      email,
      loginActiveStatus : data.status
    };

    // if (user.role == ROLE.SA.code && user.role != body.role) {
    //   if (saCount <= 1) {
    //     handleAlertClick(t('message.common.alert.last.system.administrator.not.modify'));
    //     return;
    //   }
    // }

    if (!password) {
      delete body.password;
    }

    console.log(body);

    openModal(modals.confirmModal, {
      onSubmit : (value) => {
          
        patchUsers(body)
        .then(async(res)=>{
          // console.log(res)
          await writeAuditLog({
              actionType: "UPDATE",
              targetType: "USER",
              targetId: id,
              targetName: loginId,

              apiUrl : `/api/users/${id}`,
              requestMethod : 'PATCH',
              // summary: t('message.common.log.memo.user.update'),
              summary: 'message.common.log.memo.user.update',
              payload : body
          });
//          console.log(res);
          handleAlertClick(t('message.common.alert.modify.done'));
          setIsLoading(false);
        }).catch((err)=>{
          console.log(err);
          handleAlertClick(err.response?.data?.message || err.message);
        });
      },
      onClose : () => {
        console.log('close');
      },
      message: t('message.common.alert.modify.question'),
     }); 
     reset();
  };

  const dupleCheckEmail = () => {
    if (!email) {
      handleAlertClick(t('message.common.error.text.email.input'));
      return;
    }

    if (email === user.email) {
      handleAlertClick(t('message.common.alert.email.available'));
      setIsEmailCheck(true);
      return;
    }

    getCheckDupleEmail({email:email}).then((data)=>{
      setIsEmailCheck(!data);
      if (data) {
        handleAlertClick(t('message.common.alert.email.use.other.email.input'));
      } else {
        handleAlertClick(t('message.common.alert.email.available'));
        
      }
    }).catch((err)=>{
      console.log(err);
      handleAlertClick(err.response?.data?.message || err.message);
    })
  }

  
  const handleDeleteBtnClick = (param) => {
    // console.log(saCount)
    if (saCount <= 1 && user.role === ROLE.SA.code) {
      handleAlertClick(t('message.common.alert.last.system.administrator.not.delete'));
      return;
    }
    if (saCount > 1 || user.role !== ROLE.SA.code) {
      openModal(modals.confirmModal, {
        onSubmit : (value) => {
          deleteUsers(param)
          .then(async(res) => {
            // console.log(res)
            await writeAuditLog({
                actionType: "DELETE",
                targetType: "USER",
                targetId: user.id,
                targetName: user.loginId,

                apiUrl : `/api/users/${user.id}`,
                requestMethod : 'DELETE',
                // summary: t('message.common.log.memo.user.delete'),
                summary: 'message.common.log.memo.user.delete',
                payload : null
            });
            
            document.location.href = '/setting/user/user'+window.location.search;
          }).catch((err)=>{
            console.log(err);
            handleAlertClick(err.response?.data?.message || err.message);
          });
        },
        onClose : () => {
         // console.log('close');
        },
        message: t('message.common.alert.delete.question'),
      });
    }
  }

  if (isLoading && user) {
    return (
      <div>
        {/* <div className="mro_search">
          <h5 className="mro_m_left" style={{color:"#000"}}>* 사용자 관리 수정</h5>
        </div> */}

        <form onSubmit={handleSubmit(onSubmit)}>
          {/* <input type="hidden" {...register("id")} value={user && (user.id || '')} /> */}
          <TableContainer>
            <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width" style={{borderTop:"2px solid #a2a2a2", tableLayout:"unset"}} >
              <TableBody>
                {user.company && 
                <TableRow style={{height:'70px'}}>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.company.type')}</TableCell>
                  <TableCell className="email_pl">
                    {getEnumValueByEnumNameAndCode("CompanyType", user.company?.type)?.[0]?.title}
                  </TableCell>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.company.name')}</TableCell>
                  <TableCell className="email_pl" colSpan={3}>
                    {(user && user.company?.info?.name) || ''}
                  </TableCell>
                  {/* <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.worker.certification.number')}</TableCell>
                  <TableCell className="email_pl">
                      <TextField id="certificationNumber" 
                        // aria-invalid={!isDirty ? undefined : errors.email ? "true" : "false"}
                        defaultValue={(user && user.certificationNumber) || ''}
                        sx={{ m: 1, minWidth: '90%' }} 
                      />
                      // {errors.certificationNumber && <small role="alert" style={{whiteSpace:"pre-wrap"}}><br></br>{errors.certificationNumber.message}</small>}
                  </TableCell> */}
                </TableRow>
                }
                <TableRow>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.authority')}</TableCell>
                  <TableCell className="email_pl">
                    {getEnumValueByEnumNameAndCode("RoleType", user.role)?.[0]?.title}
                  </TableCell>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.name')}</TableCell>
                  <TableCell>
                    <TextField id="userName" 
                    aria-invalid={!isDirty ? undefined : errors.name ? "true" : "false"}
                    defaultValue={(user && user.name) || ''}
                    {...register("name", {
                      required : t('message.common.error.text.name.input')
                    })} 
                    sx={{ m: 1, minWidth: '90%' }} 
                    />
                    {errors.name && <small role="alert"><br></br>{errors.name.message}</small>}
                  </TableCell>
                  <TableCell className="th" style={{width:"150px"}}>{t('login.id')}</TableCell>
                  <TableCell>
                    <TextField id="loginId" 
                      disabled
                      {...register("loginId", {
                      })} 
                      defaultValue={(user && user.loginId) || ''}
                      sx={{ m: 1, minWidth: '90%' }}
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.password')}</TableCell>
                  <TableCell>
                    <TextField id="password" 
                    {...register("password", {
                      pattern : {
                        value : passwordRegEx,
                        message : "invalid password"
                      }
                    })} 
                    type="password"
                    autoComplete="new-password"
                    sx={{ m: 1, minWidth: '90%' }} />
                    {errors.password && <small role="alert"><br></br>{errors.password.message}</small>}
                  </TableCell>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.password.confirm')}</TableCell>
                  <TableCell>
                    <TextField id="password2" 
                    {...register("password2", {
                      pattern : {
                        value : passwordRegEx,
                        message : "invalid password"
                      }
                    })} 
                    type="password"
                    autoComplete="new-password2"
                    sx={{ m: 1, minWidth: '90%' }} />
                    {errors.password2 && <small role="alert"><br></br>{errors.password2.message}</small>}
                  </TableCell>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.company.contact')}</TableCell>
                  <TableCell className="email_pl">
                    <TextField id="contact" 
                        defaultValue={user.contact || ''}
                        key={'contact'}
                        {...register("contact", {
                        })} 
                        sx={{ m: 1, minWidth: '90%' }} 
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.email')}</TableCell>
                  <TableCell className="email_pl" colSpan={3}>
                    {/* <div style={{display: "flex",alignItems: "center"}}> */}
                      <TextField id="email" 
                        aria-invalid={!isDirty ? undefined : errors.email ? "true" : "false"}
                        {...register("email", {
                          required : t('message.common.error.text.email.input'),
                          pattern : {
                            value : emailRegEx,
                            message : "invalid email address"
                          }
                        })} 
                        defaultValue={(user && user.email) || ''}
                        sx={{ m: 1, minWidth: '70%' }} 
                        onClick={()=>{setIsEmailCheck(false);}}
                        onChange={(event) => {setEmail(event.target.value); setIsEmailCheck(false);}}
                      />
                      <Button variant="contained" color="primary" size="small" sx={{top:"12px"}} onClick={()=>{dupleCheckEmail()}}>{t('message.common.btn.duplication.check')}</Button>
                      {errors.email && <small role="alert" style={{whiteSpace:"pre-wrap"}}><br></br>{errors.email.message}</small>}
                    {/* </div> */}
                  </TableCell>
                  <TableCell className="th" style={{width:"150px"}}>{t('message.common.subtitle.status')}</TableCell>
                  <TableCell className="email_pl">
                    <Controller
                      control={control}
                      name="status"
                      render={({ field: {name} }) => (
                        <CustomFormEnumSelect
                          style={{ minWidth: '90%' }}
                          label={t('message.common.subtitle.status')}
                          register={register}
                          name={name}
                          requiredMessage={t('message.common.error.text.status.select')}
                          defaultValue={user.loginActiveStatus}
                          list={getEnumValueByEnumName('ActiveStatus')}
                        />
                      )}
                      rules={{ required: true }}
                    />
                    {errors.status && <small role="alert"><br></br>{errors.status.message}</small>}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </form>

        <div className="btn_area" style={{marginTop:"10px", display:"flex", justifyContent:"space-between"}}>
          <div><Link to={'/setting/user/user'+window.location.search}><Button variant="contained" color="primary" style={{backgroundColor:"#333"}}>{t('message.common.btn.list')}</Button></Link></div>
          <div>
            {
              (id && user) ? 
              <><Button variant="contained" color="success" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.modify')}</Button>&nbsp;<Button variant="contained" color="error" onClick={()=>{handleDeleteBtnClick(id)}}>{t('message.common.btn.delete')}</Button></>
              :
              <Button variant="contained" color="primary" onClick={handleSubmit(onSubmit)}>{t('message.common.btn.write')}</Button>
            }
          </div>
        </div>
      </div>
    )
  }
}
export default UserModifySetting;